<div *ngIf="isLoading || isSubmitting" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<form *ngIf="!isLoading" class="pb-4" [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <div [style.pointer-events]="isSubmitting ? 'none' : 'auto'">
    <!-- Primary Information Accordion -->
    <div class="form-section">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Primary Information</p-accordion-header>
          <p-accordion-content>
            <app-dynamic-form
              [data]="primaryFields"
              [formGroup]="userForm"
              [subType]="'field'"
              [viewMode]="mode === 'view'"
              (fieldChanged)="onFormFieldChanged($event)"
            ></app-dynamic-form>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <!-- Tabs Section -->
    <div class="tabs-overlay" *ngIf="dynamicFormTabs.length > 0">
      <p-tabs [(value)]="activeTabIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab *ngFor="let tab of dynamicFormTabs" [value]="tab.value">
            <p class="font-normal text-sm">{{ tab.title }}</p>
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel *ngFor="let tab of dynamicFormTabs" [value]="tab.value">
            <div *ngFor="let sub_tab of tab.sub_tabs" class="mb-6">
              <h5 *ngIf="sub_tab.show_heading" class="mb-4 font-semibold">{{ sub_tab.title }}</h5>
              <app-dynamic-form
                [data]="sub_tab.content"
                [formGroup]="userForm"
                [viewMode]="mode === 'view'"
                (fieldChanged)="onFormFieldChanged($event)">
              </app-dynamic-form>
              <!-- add a line between 2 sections-->
              <hr class="my-4" *ngIf="!sub_tab.show_heading">
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>

  <div class="flex justify-end gap-2 mt-4" *ngIf="mode !== 'view'">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="onCancel()"
      [disabled]="isSubmitting"
    ></p-button>
    <p-button
      label="Save"
      type="submit"
      [disabled]="isSubmitting || userForm.invalid"
      [loading]="isSubmitting"
    ></p-button>
  </div>
</form>

